import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-wrap gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.data && _ctx.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.matk,
              class: _normalizeClass(_ctx.badgeClass)
            }, _toDisplayString(item.matk) + " | " + _toDisplayString(item.tentk), 3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(_ctx.emptyMessageClass)
        }, _toDisplayString(_ctx.emptyMessage), 3))
  ]))
}